import {Component, OnInit} from '@angular/core';
import {AppConstants} from '../../../../helpers/core/AppConstants';
import {ReportService} from '../../../../services/authenticated/report/report.service';
import {Emitters} from '../../../../helpers/core/emitters';
import {ResponseModel} from '../../../../models/response/response.model';
import {DataSharing} from '../../../../helpers/core/data.sharing';
@Component({
    selector: 'app-nr-report',
    templateUrl: './nr.report.component.html',
})

export class NRReportComponent implements OnInit {
    public level_info:any;
    public _wssp_ids_based;
    constructor(public reportService: ReportService, private emitters: Emitters) {
    }

    ngOnInit() {
        this.level_info = DataSharing.level_info();
        this._wssp_ids_based = false;
        const user_id = DataSharing.user_id();
        // let user_ids = AppConstants.WSSP_USER_IDS; 
        // let exist = user_ids.some(existingId => existingId === user_id);
        const domain_id = DataSharing.domain_id();

if(domain_id=='16'){
            this._wssp_ids_based=true;
        }
    }

    public onSubmit(data) {
        this.getReport(data);
    }

    public exportReport() {
        this.reportService.exportReportFn('nr-report');
    }

    private getReport(data) {
        const dataToSend = { ...data };
        const formatDateTime = (dateTimeStr) => {
            const [datePart, timePart, period] = dateTimeStr.split(' '); 
            const [day, month, year] = datePart.split('/'); 
            if (timePart && period) {
                return `${month}/${day}/${year} ${timePart} ${period}`;
            } else {
                return `${month}/${day}/${year}`;
            }
        };
        if (dataToSend.date) {
            dataToSend.date = formatDateTime(dataToSend.date);
        }
        if (dataToSend.end_date) {
            dataToSend.end_date = formatDateTime(dataToSend.end_date);
        }
        this.reportService.nr(dataToSend).then((response: ResponseModel) => {
            if (response.status) {
                this.reportService.reportData = response.data;
                this.emitters.change({get_report: true});
            }
        });
    }
}
